<template>
  <div style="height: 100%;overflow: auto;">
    <div class="mb-20">
      <el-input v-model="keyword.name" size="small" clearable placeholder="微信用户" class="w-200 mr-20"></el-input>
      <el-select size="small" class="mr-20" v-model="keyword.is_pay" clearable placeholder="支付状态">
        <el-option value="0" label="未支付">未支付</el-option>
        <el-option value="1" label="已支付">已支付</el-option>
      </el-select>
      <el-date-picker
          v-model="keyword.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期" class="mr-20" size="small">
      </el-date-picker>
      <el-button type="primary" size="small" @click="search">搜索</el-button>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="微信用户" prop="user.nickname"></el-table-column>
      <el-table-column label="充值方式" prop="type"></el-table-column>
      <el-table-column label="订单号" prop="order_no"></el-table-column>
      <el-table-column label="支付金额" prop="money"></el-table-column>
      <el-table-column label="浏览次数" prop="look_num"></el-table-column>
      <el-table-column label="提交时间" prop="addtime"></el-table-column>
      <el-table-column label="支付状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="pay_time"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :currentPage="page" @change="page_change"></layer-page>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";

export default {
name: "deposit_list",
  components:{LayerPage},
  data(){
    return{
      list:[],
      is_load:false,
      page:1,
      total:0,
      is_pop:false,
      select:0,
      setting:[],
      pay_no:'',
      pay_code:'',
      is_pay:false,
      keyword:{name:''}
    }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods: {
    get_list: async function () {
      if (!this.is_load) {
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.company('recharge_list', {page: this.page,keyword:this.keyword});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    search:function (){
      this.page = 1;
      this.list = [];
      this.get_list();
    },
    page_change : async function  (e){
      try{
        this.page = e;
        this.is_load = false;
        this.list = [];
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
  }
}
</script>

<style scoped>

</style>